import columnNameCollection from '@/constants/gearColumnNameCollection'

export default Object.keys(columnNameCollection)
